export enum SystemMessageType {
  info = 'info',
  error = 'error',
  success = 'success',
}
